
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { ProductCategoriesGrid } from './components/ProductCategoriesGrid';
import { AboutSection } from './components/AboutSection';
import { QualitySection } from './components/QualitySection';
import { SEO } from '../../utils/seo';

export function HomePage() {
  const schema = {
    '@type': 'WebPage',
    name: 'Horizon Signage - Professionelle Promotion-Fahnen & Werbefahnen',
    description: 'Hochwertige Promotion-Fahnen, Beachflags und Werbefahnen für B2B-Kunden in Deutschland. UV-beständiger Druck, wetterfeste Materialien, individuelle Maßanfertigung.',
    publisher: {
      '@type': 'Organization',
      name: 'Horizon Signage'
    }
  };

  return (
    <>
      <SEO
        title="Horizon Signage - Professionelle Promotion-Fahnen & Werbefahnen Deutschland"
        description="Horizon Signage bietet hochwertige Promotion-Fahnen, Beachflags und Werbefahnen für B2B-Kunden in Deutschland. UV-beständiger Druck, wetterfeste Materialien, individuelle Maßanfertigung für Messen, Events und Außenwerbung."
        keywords="Promotion-Fahnen, Werbefahnen, Beachflags, Fahnenmast-Flaggen, Werbetechnik, Deutschland"
        schema={schema}
      />
      <div className="min-h-screen">
        <Header />
        <main>
          <HeroSection />
          <ProductCategoriesGrid />
          <AboutSection />
          <QualitySection />
        </main>
        <Footer />
      </div>
    </>
  );
}
